"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.white = exports.black = exports.mellow = exports.seashell = exports.azure = exports.calm = exports.canary = exports.salmon = exports.sky = exports.lavender = exports.topaz = exports.coast = exports.apricot = void 0;
exports.apricot = '#F9C9B6';
exports.coast = '#AC6651';
exports.topaz = '#77311D';
exports.lavender = '#9287FF';
exports.sky = '#6BD9E9';
exports.salmon = '#FC909F';
exports.canary = '#F4D150';
exports.calm = '#E0DDFF';
exports.azure = '#D2EFF3';
exports.seashell = '#FFEDEF';
exports.mellow = '#FFEBA4';
exports.black = '#000000';
exports.white = '#FFFFFF';
